import React from "react";
import { useState, useEffect } from "react";
import { LoadingScreen } from "./components/LoadingScreen";

export function Root({ children, showLoadingScreen = true }: { children: React.ReactNode; showLoadingScreen?: boolean }) {
  const [isLoading, setIsLoading] = useState(showLoadingScreen);

  // Prevenir scroll durante la carga
  useEffect(() => {
    if (showLoadingScreen && isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isLoading, showLoadingScreen]);

  return (
    <div className="w-full min-h-screen bg-brand-bg overflow-x-clip font-sans text-brand-text">
      {showLoadingScreen && isLoading && <LoadingScreen onComplete={() => setIsLoading(false)} />}

      {children}
    </div>
  );
}
